<template>
  <!-- 已逾期=OVERDUE,进行中=PROCESSING,已结清=FINISH -->
  <div class="order-status">
    <img src="./images/PROCESSING.png" v-if="status === 'PROCESSING'" alt="进行中" />
    <template v-if="orderType === 'b'">
      <img src="./images/b_FINISH.png" v-if="status === 'FINISH'" alt="已结清" />
      <img src="./images/b_OVERDUE.png" v-if="status === 'OVERDUE'" alt="已逾期" />
    </template>
    <template v-else>
      <img src="./images/r_FINISH.png" v-if="status === 'FINISH'" alt="已支付" />
      <img src="./images/r_OVERDUE.png" v-if="status === 'OVERDUE'" alt="已超期" />
    </template>
  </div>
</template>

<script>

export default {
  props: {
    status: {
      type: String,
      default: ''
    },
    orderType: {
      type: String,
      default: ''
    }  
  }
  
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.order-status {
  width: 80px;
  height: 80px;
  &>img {
    width: 100%;
    height: 100%;
  }
}
</style>